module.exports = __webpack_public_path__ + "img/type_1.bd12cf96.jpg";